import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { TrendingUp, DollarSign, PieChart, Trophy } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function AnalyticsDashboard() {
  return (
    <div className="space-y-6 max-w-7xl mx-auto pb-12">
      {/* Header section */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-4 border-b border-slate-200 pb-5">
        <div>
          <h1 className="text-2xl md:text-3xl font-black text-slate-800 tracking-tight flex items-center gap-3">
            <TrendingUp className="w-8 h-8 text-emerald-600" />
            Dashboard Analytics Management
          </h1>
          <p className="text-xs md:text-sm text-slate-500 font-medium max-w-2xl mt-1">
            Pusat data analitik performa perusahaan. Pantau margin keuntungan produksi, profit sample, dan performa tim marketing secara real-time.
          </p>
        </div>
      </div>

      {/* Main navigation cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6 mt-6">
        <Link to="/office/analytics/margin-po">
          <Card className="hover:border-emerald-500 hover:shadow-md transition-all cursor-pointer h-full border-slate-200">
            <CardContent className="p-6 flex flex-col items-center text-center space-y-4">
              <div className="w-16 h-16 rounded-2xl bg-emerald-50 flex items-center justify-center">
                <DollarSign className="w-8 h-8 text-emerald-600" />
              </div>
              <div>
                <h3 className="font-bold text-lg text-slate-800">Margin PO</h3>
                <p className="text-xs text-slate-500 mt-1">Laporan detail rugi laba khusus untuk PO Produksi Massal.</p>
              </div>
            </CardContent>
          </Card>
        </Link>

        <Link to="/office/analytics/margin-sample">
          <Card className="hover:border-amber-500 hover:shadow-md transition-all cursor-pointer h-full border-slate-200">
            <CardContent className="p-6 flex flex-col items-center text-center space-y-4">
              <div className="w-16 h-16 rounded-2xl bg-amber-50 flex items-center justify-center">
                <PieChart className="w-8 h-8 text-amber-600" />
              </div>
              <div>
                <h3 className="font-bold text-lg text-slate-800">Margin Sample</h3>
                <p className="text-xs text-slate-500 mt-1">Laporan margin khusus dari pembuatan sample produk.</p>
              </div>
            </CardContent>
          </Card>
        </Link>

        <Link to="/office/analytics/margin-custom">
          <Card className="hover:border-[#D4AF37] hover:shadow-md transition-all cursor-pointer h-full border-slate-200">
            <CardContent className="p-6 flex flex-col items-center text-center space-y-4">
              <div className="w-16 h-16 rounded-2xl bg-[#fcf9f2] flex items-center justify-center">
                <PieChart className="w-8 h-8 text-[#D4AF37]" />
              </div>
              <div>
                <h3 className="font-bold text-lg text-slate-800">Margin Custom</h3>
                <p className="text-xs text-slate-500 mt-1">Laporan margin dari invoice custom yang memiliki HPP.</p>
              </div>
            </CardContent>
          </Card>
        </Link>

        <Link to="/office/analytics/ranking">
          <Card className="hover:border-blue-500 hover:shadow-md transition-all cursor-pointer h-full border-slate-200">
            <CardContent className="p-6 flex flex-col items-center text-center space-y-4">
              <div className="w-16 h-16 rounded-2xl bg-blue-50 flex items-center justify-center">
                <Trophy className="w-8 h-8 text-blue-600" />
              </div>
              <div>
                <h3 className="font-bold text-lg text-slate-800">Ranking Omset</h3>
                <p className="text-xs text-slate-500 mt-1">Papan peringkat omset bulanan untuk seluruh tim marketing.</p>
              </div>
            </CardContent>
          </Card>
        </Link>

        <Link to="/office/analytics/laporan-ppn">
          <Card className="hover:border-purple-500 hover:shadow-md transition-all cursor-pointer h-full border-slate-200">
            <CardContent className="p-6 flex flex-col items-center text-center space-y-4">
              <div className="w-16 h-16 rounded-2xl bg-purple-50 flex items-center justify-center">
                <DollarSign className="w-8 h-8 text-purple-600" />
              </div>
              <div>
                <h3 className="font-bold text-lg text-slate-800">Laporan PPN</h3>
                <p className="text-xs text-slate-500 mt-1">Laporan lengkap rekapitulasi PPN untuk kepatuhan pajak perusahaan.</p>
              </div>
            </CardContent>
          </Card>
        </Link>
      </div>

      {/* Info Notice */}
      <div className="mt-8 bg-slate-50 border border-slate-200 rounded-2xl p-6 text-center max-w-3xl mx-auto">
        <h4 className="font-bold text-slate-700 text-sm mb-2">Akses Terbatas</h4>
        <p className="text-xs text-slate-500">
          Portal Analytics ini berisi data konfidensial perusahaan. Hak akses default portal ini secara eksklusif hanya diberikan kepada Owner, Finance, dan Developer.
        </p>
      </div>
    </div>
  );
}
